import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ChannelsPrograms } from 'features/channels';
import { useGetPathToEntityDetail } from '../../hooks';
import { useNavigateToJoinedPrograms } from '../hooks';

const PageChannelsPrograms = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();
  const navigateToJoinedPrograms = useNavigateToJoinedPrograms();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <AppLayout>
      <ChannelsPrograms
        getPathToProgramDetail={(id) => getPathToEntityDetail(id, { entityType: 'program' })}
        navigateToJoinedPrograms={navigateToJoinedPrograms}
        organizationId={organizationId}
      />
    </AppLayout>
  );
};

export default PageChannelsPrograms;
